__turbopack_context__.v({
  "Aside": "S2cRPq_Aside",
  "CartButton": "S2cRPq_CartButton",
  "CloseIcon": "S2cRPq_CloseIcon",
  "Container": "S2cRPq_Container",
  "FlexItem": "S2cRPq_FlexItem",
  "Header": "S2cRPq_Header",
  "OrderSummary": "S2cRPq_OrderSummary",
  "Padding": "S2cRPq_Padding",
  "Price": "S2cRPq_Price",
  "PriceTitle": "S2cRPq_PriceTitle",
  "PurchaseButton": "S2cRPq_PurchaseButton",
  "TimeDisplay": "S2cRPq_TimeDisplay",
  "Title": "S2cRPq_Title",
});
